
import React from 'react';

export const ReviewsSection: React.FC = () => {
  const reviews = [
    {
      name: 'Rahul Krishnan',
      location: 'Vyttila',
      rating: 5,
      review: 'Got my iPhone fixed in 2 hours - excellent service! The screen replacement looks perfect and the pricing was very transparent. Highly recommend Device Doctor.',
      service: 'iPhone Screen Repair',
      avatar: '/assets/customer1.jpg'
    },
    {
      name: 'Anjana Nair',
      location: 'Kadavanthra',
      rating: 5,
      review: 'Replaced my Pixel screen - looks brand new. The technicians are very skilled and the doorstep pickup service is amazing. Will definitely come back.',
      service: 'Google Pixel Repair',
      avatar: '/assets/customer2.jpg'
    },
    {
      name: 'Firoz Ahmed',
      location: 'Edappally',
      rating: 5,
      review: 'Transparent, affordable, and fast. Fixed my OnePlus charging port issue within 3 hours. Great customer service and genuine parts used.',
      service: 'OnePlus Charging Port',
      avatar: '/assets/customer3.jpg'
    },
    {
      name: 'Priya Menon',
      location: 'Kakkanad',
      rating: 5,
      review: 'Amazing water damage recovery service! They saved all my photos and contacts from my Samsung phone. Professional and reliable service.',
      service: 'Water Damage Recovery',
      avatar: '/assets/customer4.jpg'
    },
    {
      name: 'Arjun Pillai',
      location: 'Marine Drive',
      rating: 5,
      review: 'Best mobile repair shop in Kochi! Fixed my iPad screen and battery. The quality is excellent and they provide warranty on repairs.',
      service: 'iPad Screen & Battery',
      avatar: '/assets/customer5.jpg'
    },
    {
      name: 'Sneha Thomas',
      location: 'Panampilly Nagar',
      rating: 5,
      review: 'Excellent Apple Watch repair service. They fixed my Series 7 battery issue quickly and the watch works perfectly now. Highly recommended!',
      service: 'Apple Watch Battery',
      avatar: '/assets/customer6.jpg'
    }
  ];

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <i
        key={index}
        className={`ri-star-${index < rating ? 'fill' : 'line'} text-yellow-400`}
      ></i>
    ));
  };

  return (
    <section id="reviews" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-2 mb-6">
            <i className="ri-star-line text-red-600 text-2xl"></i>
            <span className="text-red-600 font-semibold text-lg">Customer Reviews</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            What Our Customers Say
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Thousands of satisfied customers across Kochi trust Device Doctor for reliable, 
            professional mobile and gadget repair services.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map((review, index) => (
            <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-center space-x-4 mb-4">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">{review.name}</h4>
                  <p className="text-sm text-gray-600">{review.location}</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-1 mb-3">
                {renderStars(review.rating)}
              </div>
              
              <p className="text-gray-700 mb-4 leading-relaxed">"{review.review}"</p>
              
              <div className="flex items-center space-x-2 text-sm">
                <i className="ri-tools-line text-red-600"></i>
                <span className="text-gray-600">{review.service}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Stats Section */}
        <div className="mt-16 bg-white rounded-2xl p-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl md:text-4xl font-bold text-red-600 mb-2">5000+</div>
              <p className="text-gray-600">Happy Customers</p>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold text-red-600 mb-2">4.9</div>
              <p className="text-gray-600">Average Rating</p>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold text-red-600 mb-2">24hrs</div>
              <p className="text-gray-600">Average Repair Time</p>
            </div>
            <div>
              <div className="text-3xl md:text-4xl font-bold text-red-600 mb-2">100%</div>
              <p className="text-gray-600">Genuine Parts</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
